/**
 * 줄바꿈(CR/LF/CRLF)을 공백 하나로 치환한다.
 * 연속된 줄바꿈은 공백 1개로 합쳐 단어가 붙는 것을 막고, 내부 공백은 보존한다.
 */
const collapseLineBreaks = (value: string) => value.replace(/[\r\n]+/g, ' ');

export default collapseLineBreaks;
